import { createFileRoute } from '@tanstack/react-router'
import { RafobaseLogo } from '@/components/rafobase-logo'

export const Route = createFileRoute('/terms')({
  component: TermsOfServicePage,
})

function TermsOfServicePage() {
  return (
    <div className="mx-auto max-w-3xl px-6 py-12">
      <div className="mb-8">
        <RafobaseLogo />
      </div>

      <h1 className="mb-2 text-3xl font-bold">Terms of Service</h1>
      <p className="mb-8 text-sm text-muted-foreground">Last updated: March 21, 2026</p>

      <div className="prose prose-neutral dark:prose-invert max-w-none space-y-6 text-sm leading-relaxed">
        <section>
          <h2 className="text-lg font-semibold">1. Acceptance of Terms</h2>
          <p>
            By accessing or using Rafobase ("the Service"), operated at base.rafo.work, you agree to
            be bound by these Terms of Service. If you do not agree, do not use the Service.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold">2. Service Description</h2>
          <p>
            Rafobase is a creator relationship management (CRM) platform that enables e-commerce
            brands to manage influencer partnerships, track user-generated content, monitor social
            media mentions, and measure creator engagement performance.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold">3. Account Responsibilities</h2>
          <ul className="ml-4 list-disc space-y-1">
            <li>You must provide accurate and complete registration information</li>
            <li>You are responsible for maintaining the security of your account credentials</li>
            <li>
              You must have the authority to connect any third-party accounts (e.g., Instagram
              Business) to the Service
            </li>
            <li>You are responsible for all activity that occurs under your account</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold">4. Instagram Integration</h2>
          <p>
            When connecting your Instagram Business account, you authorize Rafobase to access your
            account data as described in our Privacy Policy. You may disconnect your Instagram
            account at any time from the Settings page, which immediately revokes our access.
          </p>
          <p>
            Your use of Instagram data through our Service is also subject to Meta's Platform Terms
            and Developer Policies.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold">5. Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul className="ml-4 list-disc space-y-1">
            <li>Use the Service for any unlawful purpose</li>
            <li>Attempt to access accounts or data belonging to other users</li>
            <li>Interfere with or disrupt the Service infrastructure</li>
            <li>
              Use the Service to collect data in violation of any third-party terms of service
            </li>
            <li>Resell or redistribute data obtained through the Service</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold">6. Data and Content</h2>
          <p>
            You retain ownership of all data you upload or connect to the Service. By using the
            Service, you grant us a limited license to process and store your data solely to provide
            the Service functionality.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold">7. Service Availability</h2>
          <p>
            We strive to maintain high availability but do not guarantee uninterrupted access. The
            Service may be temporarily unavailable for maintenance, updates, or circumstances beyond
            our control.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold">8. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, Rafobase shall not be liable for any indirect,
            incidental, or consequential damages arising from your use of the Service, including but
            not limited to loss of data, revenue, or business opportunities.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold">9. Termination</h2>
          <p>
            You may terminate your account at any time by contacting us. We may suspend or terminate
            your access if you violate these Terms. Upon termination, your data will be deleted in
            accordance with our Privacy Policy.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold">10. Changes to Terms</h2>
          <p>
            We may update these Terms from time to time. We will notify registered users of material
            changes via email. Continued use after changes constitutes acceptance.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold">11. Governing Law</h2>
          <p>
            These Terms are governed by the laws of Brazil. Any disputes shall be resolved in the
            courts of São Paulo, SP.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold">12. Contact</h2>
          <p>
            For questions about these Terms, contact us at:{' '}
            <a href="mailto:support@rafo.work" className="underline">
              support@rafo.work
            </a>
          </p>
        </section>
      </div>
    </div>
  )
}
